<template>
  <div class="share-setting-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="left">
          <div class="title">上传商城分享图</div>
          <el-form
            :model="configure"
            label-width="150px"
            label-position="right"
            :rules="rules"
            ref="form"
            class="configure-form"
          >
            <el-form-item class="img_item" prop="pic" label="">
              <div class="addImg">
                <p class="tips">请上传分享图,格式.jpg.png</p>
                <div class="img-box">
                  <img
                    ref="img"
                    class="img"
                    :src="configure.pic"
                    v-if="configure.pic"
                  />
                  <div class="icon" v-else>
                    <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                    <p>图片</p>
                    <p class="tip">支持扩展名：.jpg .png</p>
                  </div>
                  <input
                    type="file"
                    class="file"
                    ref="img"
                    accept="image/png, image/jpg, image/jpeg"
                    @change="addChangeImg"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="分享语"
              prop="slogan"
              class="form-item"
            >
              <el-input
                size="small"
                placeholder="请输入分享语"
                class="input"
                v-model="configure.slogan"
                style="width: 270px"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-box">
            <button class="btn" @click="handleShare">保存设置</button>
          </div>
        </div>
        <div class="right">
          <div class="title">上传家庭分享图</div>
          <el-form
            :model="configure2"
            label-width="150px"
            label-position="right"
            :rules="rules"
            ref="form"
            class="configure-form"
          >
            <el-form-item class="img_item" prop="pic" label="">
              <div class="addImg">
                <p class="tips">请上传分享图,格式.jpg.png</p>
                <div class="img-box">
                  <img
                    ref="img"
                    class="img"
                    :src="configure2.pic"
                    v-if="configure2.pic"
                  />
                  <div class="icon" v-else>
                    <p><i class="el-icon-plus" style="font-size: 24px"></i></p>
                    <p>图片</p>
                    <p class="tip">支持扩展名：.jpg .png</p>
                  </div>
                  <input
                    type="file"
                    class="file"
                    ref="img"
                    accept="image/png, image/jpg, image/jpeg"
                    @change="addChangeImg2"
                  />
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="btn-box">
            <button class="btn" @click="handleShareFamily">保存设置</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'share-setting',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '分享设置'
      },
      configure: {
        way: 1,
        pic: '',
        slogan: ''
      },
      rules: {},
      loading: 0,
      configure2: {
        way: 2,
        pic: '',
      },
    };
  },
  mounted() {
    this.getShareInfo();
    this.getShareInfoFamily();
  },
  computed: {},
  methods: {
    // 获取分享详情
    getShareInfo() {
      this.loading++;
      this.httpGet(this.$root.getShareInfo, {
        way: 1
      }).then(
        (res) => {
          this.loading--;
          this.configure = {
            ...this.configure,
            pic: res.pic,
            slogan: res.slogan
          };
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getShareInfoFamily() {
      this.loading++;
      this.httpGet(this.$root.getShareInfo, {
        way: 2
      }).then(
        (res) => {
          this.loading--;
          this.configure2 = {
            ...this.configure2,
            pic: res.pic
          };
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 保存修改
    handleShare() {
      this.loading++;
      this.httpPut(this.$root.updateShare, this.configure).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getShareInfo();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleShareFamily() {
      this.loading++;
      this.httpPut(this.$root.updateShare, this.configure2).then(
        (res) => {
          this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getShareInfoFamily();
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.configure, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.img.value = '';
        // this.$refs.form.clearValidate(['pic']);
      });
    },
    addChangeImg2(e) {
      this.upPic(e, (res) => {
        this.$set(this.configure2, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.img.value = '';
        // this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item{
    margin-bottom: 20px !important;
}
.share-setting-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
    //   background: white;
      box-sizing: border-box;
    //   padding: 24px;
      border-radius: 2px;
      flex-x();

      .left, .right{
        flex: 1;
        background: #fff;
        height: 100%;
        padding: 30px;
        box-sizing: border-box;
      }
      .left{
          margin-right: 10px;
      }

      .right{
          margin-left: 10px;
      }

      .title {
        word(20px, #404157);
        font-weight: 550;
      }

      .configure-form {
        margin: 50px 80px 0;

        .input {
          width: 150px;
        }
      }

      .tip {
        word(15, #EA0000);
        margin-top: 24px;
        margin-left: 80px;
      }

      .btn-box {
        .btn {
          confirm-btn();
          width: 145px;
          height: 32px;
          margin-top: 24px;
          margin-left: 190px;
        }
      }

      .addImg {
        .tips {
          // margin-bottom: 12px;
          line-height: 40px;
        }

        .icon {
          width: 208px;
          height: 280px;
        }

        .img {
          width: 208px;
          height: auto;
        }

        p {
          margin: 0;
        }

        .tip {
          color: gray9;
        }
      }
    }
  }
}
</style>
